import { bscTestnet } from "viem/chains";

export const environment = {
    production: false,
    SUPPORTED_CHAINS: [bscTestnet],
    ENCRYPT_LOCAL_STORAGE: false,
    LANGUAGES_FILE_PATH: 'assets/i18n/',
    LOCAL_STORAGE_SECRET: 'D96Q2M84E3400063E8366912AQ45488H',
    WALLET_CONNECT_PROJECT_ID: '00507133e3e070843a1beab55a1ebfe2',
    dev_url:'https://web3.alphaomegacoin.com',
    PLAY_STORE_LINK: 'https://rtyxi.test-app.link/ifoMSAJzDSb/?ref=',
    NETWORK_ID:['0x61'],
    API_BASE_URL: 'https://stagingtokendistributionbackend.alphaomegacoin.com/api/v1',
    CHAIN_ID: 97,
    NETWORK_NAME:'BSC-TESTNET',
    NETWORK_SYMBOL:'bsc',
    NETWORK_CURRENCY:'BNB',
    TRANSACTION_URI: 'https://testnet.bscscan.com/tx/',
    TEST_CHAIN: 'bsc',
    RPC_URL: "https://bsc-testnet.blockpi.network/v1/rpc/public",   
    DISTRIBUTION_START_DATE: "May 2025",
    WEB3_APP_URL:'https://aoc-user.seaswap.co/',
    EN_AUDIT_LINK:"https://drive.google.com/file/d/1yXaQjWzjK0bQZWU7Gvt32y1DQIJKAZpO/view",
    FR_AUDIT_LINK:"https://drive.google.com/file/d/19PqMLKG5pkqBgaOvo4ZqDfiLoJ9B2NMy/view",
    EN_WHATSAPP_LINK:"https://whatsapp.com/channel/0029Vb5qc5JGk1FpNl8qy30g",
    FR_WHATSAPP_LINK:"https://whatsapp.com/channel/0029VaGARw98PgsOIqrx9Q3J",
    PLAYSTORE_LINK:"https://rtyxi.test-app.link/ifoMSAJzDSb/?ref=",
    DIRECT_APP_LINK_PLAY_STORE: 'https://play.google.com/store/apps/details?id=com.alpha_omega_coin',
    DAPP_URL: 'https://stagingtokendistribution.alphaomegacoin.com/'
};
